import api from "./api";

class TimeSyncService {
  constructor() {
    this.timeOffset = 0;
    this.syncing = null;
  }

  async initialize() {
    if (!this.syncing) {
      this.syncing = this.syncTime();
    }
    return this.syncing;
  }

  async syncTime() {
    try {
      const response = await api.get("/common/server-time/");
      const serverTime = new Date(response.data.server_time).getTime();
      const localTime = new Date().getTime();
      this.timeOffset = serverTime - localTime;
    } catch (error) {
      console.error("Failed to sync time with server:", error);
      // Reset offset if sync fails to avoid using stale data
      this.timeOffset = 0;
    }
  }

  now() {
    const localTime = new Date().getTime();
    return new Date(localTime + this.timeOffset);
  }
}

const timeSyncService = new TimeSyncService();
export default timeSyncService;
